export let BASE_URL,AUTH_URL,LOGIN_ROUTE,UAE_PASS_ROUTE
export const ROUTES = {
  USER_LIST_DISPLAY: "/account-details",
  DASHBOARD_LOGIN: "/dashboard/login",
  ACCOUNT_DETAILS :"/account-details/:masterDataId",
  DASHBOARD : "/dashboard",
  FORGET_PASSWORD :"/dashboard/forgot-password",
  RESET_PASSWORD :"/dashboard/reset-password",
  FORM_DISPLAY :"/formSubmission/:primaryWorkflowId/:userId/:subWfId",
  DYNAMIC_FORMS :"/formSubmission/dynamicForms/:redirectionConfigId",
  CONSENTS:"/consents/:primaryWorkflowId/:userId/:subWfId", // Not used anymore
  UPDATE_CONDITIONAL_REDIRECTION: "/formSubmission/:primaryWorkflowId/:userId",
  UPDATE_DYNAMIC_REDIRECTION: "/formSubmission/dynamicworkflow/:primaryWorkflowId/:userId/:subWfId",
  // UPDATE_CONDITIONAL_REDIRECTION: "/formSubmission/:encyrptedId",
  CONDTIONAL_RENDERING:"/formSubmission/:redirectionConfigId",
  CLIENT_DETAIL : "/dashboard/:primaryWorkflowId",
  DASHBOARD_FORMS : "/dashboard/form/:redirectionConfigId",
  CLIENT_DETAIL_DASHBOARD : "/dashboard-detail/:primaryWorkflowId/:module_id",
  DASHBOARD_LISTING: "/dashboard-listing",
  UPDATE_SUCCESSFUL: "/dashboard/form/:redirectionConfigId/update-successful",
  APPLICANTION_SUBMITTED_SUCCESSFULLY: "/update-successful",
  USER_APPLICANTION_SUBMITTED_SUCCESSFULLY: "/update-successful/:subWfId",
  APPLICATION_STATUS_TRACKING : "/application-status-tracking/:subWfId",
  SUPPORTING_DOCUMENTS : "/supporting-documents/:organisationId/:primaryWorkflowId/:subWfId/:requestId",
  SUCCESS_LOADER: "/success-loader",
  ROUTE_HOME: "/app/:branchName",
  PAYMENT:"/payment/:paymentTransactionId/:userId",
  PAYMENT_CONFIRMATION:"/payment-confirmation/:primaryWorkflowId/:userId/:subWfId",
  PAYMENT_SUCCESS:"/payment-success/:paymentId/:userId",
  ERROR:"/error",
  BULK_WORKFLOW_CREATION:"/bulk/:redirectionConfigId/:bulkConfigId",
};

// Development
console.log("Environment -> ",process.env.REACT_APP_ENV)
if (process.env.REACT_APP_ENV === "DEVELOPMENT") {
  BASE_URL = "http://localhost:3022/api"
  AUTH_URL = "https://in-accounts.qa-signdesk.com"
  LOGIN_ROUTE = "https://in.qa-signdesk.com/accounts/login"
  // AUTH_URL = "https://in-accounts.staging-signdesk.com"
  // LOGIN_ROUTE = "https://in.staging-signdesk.com/accounts/login"
  UAE_PASS_ROUTE = "https://uae-pass-verify.staging-signdesk.com/api"
}

// QA
if (process.env.REACT_APP_ENV === "QA") {
  BASE_URL = "https://in-unified.qa-signdesk.com/api"
  AUTH_URL = "https://in-accounts.qa-signdesk.com"
  LOGIN_ROUTE = "https://in.qa-signdesk.com/accounts/login"
  UAE_PASS_ROUTE = "https://uae-pass-verify.staging-signdesk.com/api"
}

// STAGING
if (process.env.REACT_APP_ENV === "STAGING") {
  BASE_URL = "https://in-unified.staging-signdesk.com/api"
  AUTH_URL = "https://in-accounts.staging-signdesk.com"
  LOGIN_ROUTE = "https://in.staging-signdesk.com/accounts/login"
  //plz change the url once we received
  UAE_PASS_ROUTE = "https://uae-pass-verify.staging-signdesk.com/api"
}

// PRODUCTION
if (process.env.REACT_APP_ENV === "PRODUCTION") {
  BASE_URL = "https://in-unified.signdesk.com/api"
  AUTH_URL = "https://in-accounts.signdesk.com"
  LOGIN_ROUTE = "https://in.signdesk.com/accounts/login"
  //plz change the url once we received
  UAE_PASS_ROUTE = "https://uae-pass-verify.staging-signdesk.com/api"
}

// DEMO
if (process.env.REACT_APP_ENV === "DEMO") {
  BASE_URL = "https://in-demo-unified.signdesk.com/api"
  AUTH_URL = "https://in-demo-accounts.signdesk.com"
  LOGIN_ROUTE = "https://in-demo.signdesk.com/accounts/login"
  //plz change the url once we received
  UAE_PASS_ROUTE = "https://uae-pass-verify.staging-signdesk.com/api"
}